export default {
    400: {
        title: "Brutta richiesta",
        header: "@:views.errors.400.title",
        html: "Richiesta non valida. Riprova più tardi."
    },
    401: {
        title: "Abbiamo riscontrato un errore durante l'accesso",
        header: "@:views.errors.401.title",
        html: "Contattare <a href='{email}' target='_blank'>l'assistenza</a> ."
    },
    404: {
        title: "Pagina non trovata",
        header: "@:views.errors.404.title"
    },
    403: {
        title: "Accesso non consentito",
        header: "Accesso non consentito",

        contact: "O-I La periferica è disponibile solo per i dipendenti. Se sei un dipendente e vedi questo messaggio, contatta il tuo ufficio locale People &amp; Culture per aggiornare il tuo stato.",

        subject: "Attrezzatura - Idoneità",

        html: "<p class='text-start'>@:views.errors.403.eligibility @:views.errors.403.contact</p>",
        error: {
            disabled: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Al momento non sei idoneo. Contatta <a href='#' role='button' data-widget-trigger='{widgetOptions}'>l'assistenza</a> per ulteriori informazioni.</p>"
            },
            "not-active": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Al momento non sei idoneo. Per maggiori informazioni, rivolgiti al tuo ufficio locale People &amp; Culture.</p>"
            },
            "not-allowed":{
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I La periferica è disponibile solo per i dipendenti. Se sei un dipendente e vedi questo messaggio, contatta il tuo ufficio locale People &amp; Culture per aggiornare il tuo stato.</p>"
            },
            "no-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Non hai un manager attivo elencato nel tuo profilo ServiceNow. Contatta il tuo rappresentante locale di People &amp; Culture per aggiornare il tuo manager.</p>"
            },
            "self-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Il tuo responsabile è impostato come te nel tuo profilo ServiceNow. Contatta il tuo rappresentante locale di People &amp; Culture per aggiornare il tuo responsabile.</p>"
            },
            "no-location": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Non hai una sede elencata nel tuo profilo ServiceNow. Contatta il tuo rappresentante locale di People &amp; Culture per aggiornare la tua sede.</p>"
            },
            eligibility: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I La periferica è disponibile solo per i dipendenti. Se sei un dipendente e vedi questo messaggio, contatta il tuo ufficio locale People &amp; Culture per aggiornare il tuo stato.</p>",
            },
            "eligibility-location": {
                header: "",
                html: "Grazie per l'interesse dimostrato per O-I Peripheral. Al momento questo programma non è disponibile nel tuo Paese.",
            },
            "secondary-account": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Stai tentando di accedere a O-I Periferica con un account secondario. Prova ad accedere nuovamente con il tuo account principale.</p>"
            },
            "empty-core-id": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Il tuo account ServiceNow non ha un nome account. Contatta il tuo rappresentante locale People &amp; Culture per aggiornare il tuo account.</p>"
            },
            country: {
                header: "@:views.errors.403.header",
                html: " @:views.errors.403.eligibility @:views.errors.403.contact",
            },
            "no-permissions": {
                header: "Nessun accesso",
                subject: "Nessun accesso",
                html: "Non hai i permessi per aprire questa pagina.",
            },
            "virtual-denied": {
                header: "Sembra che tu sia un po' in anticipo...",
                html: "<p class='text-start'>Grazie per l'interesse dimostrato per O-I Peripheral. Sembra che tu abbia raggiunto il sito prima di essere abilitato e invitato direttamente. O-I Peripheral viene implementato gradualmente, paese per paese e per gruppi di utenti. Una volta attivato, riceverai un'e-mail contenente un invito personale con le istruzioni.</p><p class='text-start'> Per domande o problemi relativi al tuo ordine o al sito, clicca su <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Assistenza</a> .</p>",
            }
        }
    },
    500: {
        title: "Errore imprevisto",
        header: "@:views.errors.500.title",
        message: "Si è verificato un errore. Riprova più tardi."
    },
    code: {
        title: "Errore imprevisto",
        message: "@:views.errors.code.title",
        error: "Errore {code}."
    }
}